import type { UniclientCartProps } from './components/cart';
import type { UniclientPageFrame } from './frame';
import type { UniclientStepPresentation } from './step';

type CartProps<TComponentAttributes extends string> = Omit<UniclientCartProps<TComponentAttributes>, 'type'> &
  Omit<UniclientPageFrame, 'action' | 'lockHistory' | 'progress' | 'summary' | 'type'> &
  Omit<UniclientStepPresentation<TComponentAttributes>, 'component' | 'frame' | 'type'>;

export function cart<TComponentAttributes extends string>({
  title,
  header = {},
  ...restProps
}: CartProps<TComponentAttributes>): UniclientStepPresentation<TComponentAttributes> {
  return {
    frame: {
      type: 'page',
      title,
      header,
      lockHistory: true,
    },
    component: {
      type: 'cart',
      ...restProps,
    },
  };
}
